<template>
    <div class="row gutters mt-1">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex overflow-auto" style="gap: 10px">
            <router-link to="/cliente" class="flex-grow-1">
                <div class="info-stats4" @click="$router.push('/cliente')" style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-users"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ peoples.total }}</h3>
                        <p>{{ this.t('DASHBOARD.PEOPLES') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link :to="hasAllotments ? '/reserva' : '/'" class="flex-grow-1">
                <div class="info-stats4" @click="$router.push('')" style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-lock-open"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ reservesActive.total }}</h3>
                        <p>{{ this.t('RESERVE.INDEX_TITLE') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link to="/loteamento" class="flex-grow-1">
                <div class="info-stats4">
                    <div class="info-icon">
                        <i class="icon-grid"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ allotments.total }}</h3>
                        <p>{{ this.t('ALLOTMENT.INDEX_TITLE') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link to="/lote" class="flex-grow-1">
                <div class="info-stats4">
                    <div class="info-icon">
                        <i class="icon-map-pin"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ lots.total }}</h3>
                        <p>{{ this.t('LOTS.INDEX_TITLE') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link to="/" class="flex-grow-1"
                         v-if="validatePermissions('ConfigClickSign:index') && hasConfigClickSign">
                <div class="info-stats4" @click="openClickSign"
                     style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-border_color"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ clicksign_documents?.total }}</h3>
                        <p>{{ this.t('ASSIGN.ASSIGNS') }}</p>
                    </div>
                </div>
            </router-link>
            <router-link to="/documentos" class="flex-grow-1" style="min-width: max-content">
                <div class="info-stats4" @click="$router.push('')" style="cursor: pointer">
                    <div class="info-icon">
                        <i class="icon-cloud_upload"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ this.formatSize(drive.total) }} /
                            {{ drive.maxStore ? formatMaxStore(drive.maxStore) : '0.00' }}
                            {{ getExtensionSize(drive.maxStore) }} </h3>
                        <p>{{ this.t('DASHBOARD.TOTAL_STORED_AVAILABLE') }}</p>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import permission from '../../../components/permission';
import ConfigClickSign from '../../../services/ConfigClickSign';
import {mapState} from 'vuex';

export default {
    name: "cardsGeralRedirectionsComponent",
    props: ['peoples', 'reservesActive', 'allotments', 'lots', 'clicksign_documents','drive'],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    computed:{
        ...mapState({
            hasConfigClickSign: 'hasConfigClickSign',
            hasAllotments: 'hasAllotments',
        }),
    },
    mixins: [permission],
    methods:{
        openClickSign(){
            this.$store.commit('changeLoading', true);
            ConfigClickSign.getRedirectAssign().then(resp => {
                window.open(`${process.env.VUE_APP_CLICK_SIGN_FRONT_HOST}/loginDisponibilidade/${resp.data}`,'blank');
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        formatSize(fileSize) {
            if (!fileSize) return '0.0';
            if (fileSize < 1000) return `${fileSize} Bytes`;
            if (fileSize > 1000 && fileSize < 1000000) return `${(fileSize / 1000).toFixed()} KB`;
            if (fileSize >= 1000000 && fileSize < 1000000000) return `${(fileSize / 1000000).toFixed(2)} MB`;
            if (fileSize >= 1000000000) return `${(fileSize / 1000000000).toFixed(2)} GB`;
        },
        formatMaxStore(value) {
            if (value < 1) {
                return (value * 1000).toFixed(1);
            }
            return value
        },
        getExtensionSize(size) {
            if (size < 1) {
                return 'MB';
            } else return 'GB';
        },
    }
}
</script>

<style scoped>

</style>